import utils from './utils';

/**
 * Clase FileWrapper
 *
 * Permite manipular archivos y obtener información útil como el tamaño en MB o su representación en base64.
 */
export class FileWrapper {
  // eslint-disable-next-line no-useless-constructor
  constructor(public file: File) {}

  /**
   * Obtiene el tamaño del archivo en megabytes.
   * @returns {number} Tamaño en MB.
   */
  getMbSize() {
    return this.file.size / (1024 * 1024);
  }

  /**
   * Convierte el archivo a una cadena base64.
   * @returns {Promise<string|ArrayBuffer>} Promesa con el string base64.
   */
  getBase64() {
    return utils.getBase64(this.file);
  }

  /**
   * Obtiene el archivo como un arreglo de bytes (base64).
   * @returns {Promise<string|ArrayBuffer>} Promesa con el string base64.
   */
  getByteArray() {
    return utils.getBase64(this.file);
  }
}
